import React from 'react'
import RealEstateTechstack from '../../Techstack/RealEstateTechstack'

const TeckStackPDF = () => {
  return (
    <div className="px-20 flex justify-center items-center " style={{ height: "100vh",transform:"scale(1.35)" }}>
    <div >
      <RealEstateTechstack />
    </div>
  </div>
  )
}

export default TeckStackPDF